import deliveryNoteResource from "../resources/deliveryNoteResource";
import DeliveryNote from "../domain/deliveryNote";

export default {
  async findByFilter (filter) {
    const params = {date: filter.date.format('YYYY-MM-DD'), customerId: filter.customerId};

    const response = await deliveryNoteResource.query(_.pickBy(params, _.identity));
    if (response.ok) {
      return response.data.map((deliveryNoteData) => new DeliveryNote(deliveryNoteData));
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./client/services/deliveryNoteService.js